var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"acc-add"},[_c('button-tooltip',{attrs:{"icon":"","x-small":"","top":"","tooltip":_vm.tooltip,"buttonClass":"acc-add-btn"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"size":_vm.size,"color":"accent"}},[_vm._v(_vm._s(_vm.icon))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }